import React from 'react';
import Toggle from '../../../Component/Toggle/Toggle';
import { useDispatch, useSelector } from 'react-redux';
import { selectionAfterFieldGoalAttempt, showShotChart } from '../../../redux/reducers/settingReducer';

const ScoringDialogs = () => {
  const settingReducer = useSelector((state) => state?.settingReducer);
  const scoringDialogs = settingReducer?.ScoringDialogs
  const dispatch = useDispatch()


  const handleToggleChange = (toggleName) => {
    if (toggleName === 'showShotChart') {
      dispatch(showShotChart(!scoringDialogs.showShotChart));
    }
    if (toggleName === 'selectionAfterFieldGoalAttempt') {
      dispatch(selectionAfterFieldGoalAttempt(!scoringDialogs.selectionAfterFieldGoalAttempt));
    }
  };

  return (
    <div className='p-2 md:p-0'>
      <p className='text-[#1A1A1A] font-bebas text-4xl '>Game mode</p>

      <div className='mt-10 max-w-[672px] w-full pb-8 border-b-[1px] border-gray-100'>

        <p className='font-montserrat font-medium text-xl flex-1 text-nowrap block'>Responsive</p>
        <div className='mt-6  w-full flex flex-col gap-4' >
          <div className='w-full gap-[26px] flex justify-between items-center'>
            <p className='text-sm md:text-base font-montserrat font-medium text-black'>Show players who may get assist after FG made</p>

          <p className='font-bebas text-xl text-[#1A1A1A]'>on</p>
          </div>
          <div className='w-full gap-[26px] flex justify-between items-center'>
            <p className='text-sm md:text-base font-montserrat font-medium text-black'>Show players who may get rebound after FG missed</p>

<p className='font-bebas text-xl text-[#1A1A1A]'>on</p>
          </div>
          <div className='w-full gap-[26px] flex justify-between items-center'>
            <p className='text-sm md:text-base font-montserrat font-medium text-black'>Show players who may get turnover after steal</p>

            <p className='font-bebas text-xl text-[#1A1A1A]'>on</p>
          </div>
          <div className='w-full gap-[26px] flex justify-between items-center'>
            <p className='text-sm md:text-base font-montserrat font-medium text-black'>Show players who may receive a personal foul</p>

            <p className='font-bebas text-xl text-[#1A1A1A]'>on</p>
          </div>
        </div>
      </div>
      <div className='mt-10 max-w-[672px] w-full pb-8 '>

        <div className='mt-6  w-full flex flex-col gap-4' >
          <div className='w-full gap-[26px] flex justify-between items-center'>
            <p className='text-sm md:text-base font-montserrat font-medium text-black'>Show shot type selection after field goal attempt</p>
            <Toggle
              checked={scoringDialogs?.selectionAfterFieldGoalAttempt}
              onChange={() => handleToggleChange("selectionAfterFieldGoalAttempt")}
            />
          </div>
          <div className='w-full gap-[26px] flex justify-between items-center'>
            <p className='text-sm md:text-base font-montserrat font-medium text-black'>Show shot chart</p>
            <Toggle
              checked={scoringDialogs?.showShotChart}
              onChange={() => handleToggleChange("showShotChart")}
            />
          </div>

        </div>
      </div>
    </div>
  );
};

export default ScoringDialogs;